import BaseClass from "./BaseClass";
import Helper from "./Helper";

const defaultOptions = {};

export default class PhoneInput extends BaseClass {

    constructor(options) {
        super(options, defaultOptions);

        this.init();
    }

    init() {
        $(document).ready(() => {
            if($('.phone').length > 0) {
                $('.phone').each(function() {
                    let countriesArray = ["al", "ad", "at", "by", "be", "ba", "bg", "hr", "cz", "dk",
                        "ee", "fo", "fi", "fr", "de", "gi", "gr", "va", "hu", "is", "ie", "it", "lv",
                        "li", "lt", "lu", "mk", "mt", "md", "mc", "me", "nl", "no", "pl", "pt", "ro",
                        "ru", "sm", "rs", "sk", "si", "es", "se", "ch", "ua", "gb"];

                    // Phone input initializing throught vanilla JS (jQuery was not working correctly)
                    let phoneInput = window.intlTelInput($(this).get(0), {
                        onlyCountries: countriesArray,
                        preferredCountries: ['cz'],
                        separateDialCode: true,
                        autoPlaceholder: "",
                        utilsScript: 'https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js' // getSelectedCountryData needs this
                    });

                    if (Helper.isLaptopOrLower()) {
                        $('#contact_number').val('');
                    }

                    let language = document.documentElement.lang;
                    language = language === 'en' ? 'gb' : language;

                    // if user is not logged show phone country based on language setting
                    if ($('[data-fillbookingdata]').length > 0 && countriesArray.includes(language)) {
                        phoneInput.setCountry(language);
                    }

                    $("#dial_code").val(phoneInput.getSelectedCountryData().dialCode);

                    // On country selection save the selected dial to hidden input
                    $(this).on("countrychange", () => {
                        $("#dial_code").val(phoneInput.getSelectedCountryData().dialCode);
                        removeDialCode();
                    });

                    $(phoneInput.telInput).on('change', () => {
                        removeDialCode();
                    });

                    function removeDialCode () {
                        const phoneVal = $(phoneInput.telInput).val();
                        const dialCode = '+' + phoneInput.getSelectedCountryData().dialCode;

                        if (phoneVal.startsWith(dialCode)) {
                            phoneInput.setNumber(phoneVal.substring(dialCode.length).trim())
                        }
                    }
                });
            }
        });
    }
}
